
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
        ProcessingDecisionType,
        RequirementDecisionViewModel
    } from "@/api-client";

    @Component
    export default class RequirementProcessingDecision extends Vue {
        @Prop({required: true})
        decision!: RequirementDecisionViewModel;

        get alertVariant() {
            switch (this.decision.type) {
                case ProcessingDecisionType.Accepted:
                    return "success";
                case ProcessingDecisionType.Rejected:
                    return "danger";
            }
            throw "Not implemented decision type."
        }

        get decisionTitle(): string {
            switch (this.decision.type) {
                case ProcessingDecisionType.Accepted:
                    return this.$ls.Applications_Requirements_ProcessingDecisionType_Accepted
                case ProcessingDecisionType.Rejected:
                    return this.$ls.Applications_Requirements_ProcessingDecisionType_Rejected
            }
            throw "Unknown decision type.";
        }
    }
